import { Answer, Content, Score } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  return {
    score: answer && answer.image && answer.image.isCorrect ? 1 : 0
  };
}
